export const QUICK_ACTIONS_BY_MENU: Record<string, { label: string; value: string, stateKey?: string, stateValue?: any }[]> = {
    0: [
        // { label: "POS Dashboard", value: "/pos/dashboard" },
        { label: "Add Dish", value: "/pos/menu-management/add-new-dish" },
        { label: "Menu Management", value: "/pos/menu-management" },
        { label: "Offer Combos", value: "/pos/offer-combos" },
        { label: "Table Management", value: "/pos/table-management" },
        { label: "Hostess View", value: "/pos/hostess-view" },
        { label: "Add Combo", value: "/pos/offer-combos/add-new-combo" },
        { label: "Manage Banners", value: "/pos/manage-banners" },
        { label: "Add Category", value: "/pos/menu-management/add-category" },
    ],

    1: [
        { label: 'Inventory Dashboard', value: '/inventory/dashboard' },
        { label: 'Supply Chain Dashboard', value: '/inventory/supply-chain-dashboard' },
        { label: 'Inventory Overview', value: '/inventory/inventory-overview' },
        { label: 'Purchases', value: '/inventory/supply-chain-management/purchases' },
        { label: 'Create Purchases', value: '/inventory/supply-chain-management/create' },
        { label: 'Invoicing', value: '/inventory/supply-chain-management/invoicing' },
        { label: 'Add Invoice', value: '/inventory/supply-chain-management/invoice' },
        { label: 'Vendor Management', value: '/inventory/supply-chain-management/supplier-management' },
        { label: 'Add Vendor', value: '/inventory/supply-chain-management/supplier-management', },
        { label: 'Setup Auto Ordering', value: '/inventory/supply-chain-management/create', stateKey: 'fromAutoOrdering', stateValue: true },
        { label: 'Stock Real Time', value: '/inventory/stock-real-time' },
        { label: 'Stock Reconciliation', value: '/inventory/stock-real-time/stock-reconciliation' },
        { label: 'Seasonal Patterns', value: '/inventory/stock-real-time/season-patterns' },
        { label: 'Branch Transfer', value: '/inventory/stock-real-time/branch-transfer' },
        { label: 'Waste/Cancellation Management', value: '/inventory/waste-cancellation-management' },
        { label: 'Add SKU Wastage', value: '/inventory/waste-cancellation-management', stateKey: 'openAddWastage', stateValue: true },
        { label: 'Add Cancellation', value: '/inventory/waste-cancellation-management', stateKey: 'openAddCancellation', stateValue: true },
        { label: 'SKU Management', value: '/inventory/sku' },
        { label: 'Add Recipes', value: '/inventory/recipes/add-new-recipe', stateKey: 'from', stateValue: 'RECIPE_PAGE' },
    ],

    2: [
        { label: "Add Employee", value: "/staffing/add-employee" },
        { label: "Employee Directory", value: "/staffing/employee-directory" },
        { label: "Employee Attendance", value: "/staffing/employee-attendance" },
        { label: "Shift Planning", value: "/staffing/shift-planning" },
        { label: "Shift settings", value: "/staffing/staff-settings" },
    ],

    3: [
        { label: "CRM Dashboard", value: "/crm/dashboard" },
        { label: "Customer Segment", value: "/crm/customer-segments-profiles" },
        { label: "Add Customer", value: "/crm/members-info" },
        { label: "Groups", value: "/crm/customer-segment/groups" },
        { label: "All Campaigns", value: "/crm/campaign-control/all-campaigns" },
        { label: "Create Campaign", value: "/crm/campaign-control/create-campaigns" },
        { label: "Members Info", value: "/crm/members-info" },
        { label: "Campaign Control", value: "/crm/campaign-control" },
        { label: "Rewards Dashboard", value: "/crm/loyalty-rewards" },
        { label: "Loyalty & Rewards", value: "/crm/loyalty-rewards/all-loyalty-rewards" },
        { label: "Create Rewards", value: "/crm/loyalty-rewards/create-reward" },
        { label: "Feedback & Ratings", value: "/crm/feedback-ratings" },
    ],

    4: [
        { label: "Finance Dashboard", value: "/finance/dashboard" },
        { label: "Profit Analytics", value: "/finance/profit-analytics" },
        { label: "Add Expense", value: "/finance/profit-analytics" },
        { label: "Sales Report", value: "/finance/sales-report" },
        { label: "Taxation & Compliance", value: "/finance/taxation-compliance" },
        { label: "Transactions", value: "/finance/transactions" },
        { label: "Total Revenue", value: "/finance/profit-analytics/total-revenue" },
        { label: "COGS Report", value: "/finance/profit-analytics/cogs" },
        { label: "Gross Profit", value: "/finance/profit-analytics/gross-profit" },
        { label: "Total Expenses", value: "/finance/profit-analytics/total-expenses" },
        { label: "Net Profit", value: "/finance/profit-analytics/net-profit" },
        { label: "Profit & Loss Report", value: "/finance/profit-analytics/profit-loss-report" },
    ],

    5: [
        { label: "Dashboard", value: "/restaurant-admin/dashboard" },
        { label: "Payment Settings", value: "/restaurant-admin/payment-settings" },
        { label: "Finance & Analysis", value: "/restaurant-admin/finance-analysis" },
        { label: "RBAC System", value: "/restaurant-admin/rbac" },
        { label: "Create Role", value: "/restaurant-admin/settings/create-role" },
        { label: "Outlet Management", value: "/restaurant-admin/multi-outlets" },
        { label: "Audit Log", value: "/restaurant-admin/audit-logs" },
        { label: "FX Support", value: "/restaurant-admin/fx-support" },
        { label: "Add Kitchen", value: "/restaurant-admin/kds-kot" },
    ],
};
